export default (function (currentRoute, _a) {
    var defaultCurrency = _a.defaultCurrency, value = _a.value;
    return "/".concat(value, "/").concat(defaultCurrency.toLowerCase()).concat(currentRoute.path);
});
